/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Mbongeni Nsingo",
  kicker: "All things data, AI and software",
  title: "Hey there! I'm Mbongeni Nsingo.",
  role: "Data Scientist & Full-Stack Developer",
  heroSlides: [
    {
      title: "Hey there ! I'm Mbongeni Nsingo",
      lead: "Data Scientist",
      highlight: "& Developer",
      tag: "All things Data, AI and Software"
    },
    {
      title: "Design Classy and Strategic",
      lead: "Brand",
      highlight: "Perception.",
      tag: "Product-minded builder"
    },
    {
      title: "Original Systems Features With High",
      lead: "Quality",
      highlight: "Code.",
      tag: "Ever-ready, Mobi First!"
    }
  ],
  subTitle: emoji(
    "A Data Scientist, Full-Stack Developer, and Co-Founder of CogniEdge Technologies. I specialize in building custom, data-driven web applications and AI solutions to help businesses scale and operate smarter."
  ),
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/mboecreator",
  linkedin: "https://www.linkedin.com/in/mbongeni-nsingo-456912291",
  gmail: "mbongeninsingo84@gmail.com",
  gitlab: "",
  facebook: "https://www.facebook.com/profile.php?id=100078032067756",
  medium: "",
  stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "My Own Developer's and Design Skills",
  subTitle: "Power // attainments across software engineering, data science, AI automation, and business-focused product delivery.",
  designSkills: ["Product Thinking", "UI / UX Design", "Brand Systems"],
  languageSkills: ["English", "Ndebele", "Shona"],
  skills: [
    emoji("⚡ Build full-stack web applications using React, JavaScript, HTML5 & CSS3 on the frontend, and Python/Node.js on the backend."),
    emoji("⚡ Develop and deploy AI & Machine Learning models using TensorFlow, Hugging Face, and LangChain for real-world automation."),
    emoji("⚡ Design and manage databases with PostgreSQL and integrate RESTful APIs using Postman and backend frameworks."),
    emoji("⚡ Deploy and scale applications on cloud infrastructure: AWS (EC2, S3, Lambda) and Microsoft Azure."),
    emoji("⚡ Automate workflows with Python scripting, build data pipelines, and use Docker for containerized deployments."),
    emoji("⚡ Version-controlled development using Git & GitHub, following clean code principles and modular architecture.")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "TensorFlow",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    }
  ],
  toolsTitle: "Tech Stack",
  tools: [
    "Python",
    "JavaScript",
    "React",
    "Node.js",
    "PostgreSQL",
    "TensorFlow",
    "LangChain",
    "Hugging Face",
    "Docker",
    "AWS",
    "Azure",
    "Git & GitHub"
  ],
  display: true // Set false to hide this section, defaults to true
};

// About Section

const aboutSection = {
  display: true,
  label: "//Words About",
  title: "Mbongeni Nsingo.",
  subTitle: "Innovative solutions to boost your creative projects",
  image: require("./assets/images/aboutPortrait.png"),
  imageAlt: "Portrait of Mbongeni Nsingo",
  imageCaption: "Mbongeni develops.",
  factsImage: require("./assets/images/aboutFacts.png"),
  factsIntro:
    "I'm a Christian who believes in God, driven by purpose and growth. I'm passionate about business, technology, and building impactful ideas that inspire change and create lasting value.",
  description: [
    "I build custom data-driven web applications, AI systems, and automation workflows for founders, teams, and businesses that need practical digital products, not just pretty screens.",
    "My work focuses on software development, machine learning, and building intelligent systems that solve real-world problems. I aim to create solutions that are both practical and scalable."
  ],
  services: ["Web Design", "AI Systems", "Data Pipelines", "Automation"],
  facts: [
    {
      count: "30",
      label: "Finished projects"
    },
    {
      count: "500",
      label: "Working hours (workaholic)"
    },
    {
      count: "100",
      label: "Coffee cups"
    }
  ]
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Midlands State University",
      logo: require("./assets/images/msuLogo.png"),
      subHeader: "BSc in Data Science and Informatics (BS08)",
      duration: "2023 - Present",
      desc: "Studying Data Science with a focus on ethical AI, machine learning, and building digital solutions for the African context.",
      descBullets: [
        "Researching ethical AI and responsible data practices.",
        "Hands-on experience with Python, TensorFlow, AWS, Azure, and web technologies."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python & Machine Learning",
      progressPercentage: "90%"
    },
    {
      Stack: "Full-Stack Web Development",
      progressPercentage: "85%"
    },
    {
      Stack: "Data Engineering & Cloud",
      progressPercentage: "80%"
    },
    {
      Stack: "AI / NLP (LangChain, HuggingFace)",
      progressPercentage: "78%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Application and Systems Developer Intern",
      company: "Telco Broadband and Beyond",
      companylogo: require("./assets/images/telcoLogo.png"),
      date: "Recent",
      desc: "Supported cross-functional engineering teams by focusing on application development, systems integration, and automation.",
      descBullets: [
        "Utilized Postman for API testing and system integration.",
        "Built automated data pipelines to move and clean data efficiently using cloud platforms.",
        "Collaborated with teams to ensure software systems communicated effectively."
      ]
    },
    {
      role: "Data Science Student",
      company: "Midlands State University",
      companylogo: require("./assets/images/msuLogo.png"),
      date: "2023 – Present",
      desc: "Pursuing a BSc in Data Science and Informatics (BS08) with a focus on ethical AI and societal impact.",
      descBullets: [
        "Researching ethical AI and responsible data practices for the African context.",
        "Developing predictive models, conversational agents, and data-driven solutions."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Websites & Digital Solutions",
  subtitle: "A curated list of systems, AI tools, and web products built or shaped through CogniEdge Technologies.",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "AI-Powered Chatbots",
      projectCategory: "AI Automation",
      projectFilters: ["AI", "Web Apps"],
      projectDesc: "Built conversational agents using frameworks like LangChain, Hugging Face, and TensorFlow to improve how machines understand human intent through NLP.",
      footerLink: [
        {
          name: "View Project",
          url: "#"
        }
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Predictive Modeling & Pipelines",
      projectCategory: "Data Engineering",
      projectFilters: ["Data", "Cloud"],
      projectDesc: "Developed models to forecast trends for business analytics and built automated data pipelines using Python, AWS, and Azure to clean and move data efficiently.",
      footerLink: [
        {
          name: "View Details",
          url: "#"
        }
      ]
    },
    {
      image: require("./assets/images/telcoLogo.png"),
      projectName: "Systems Integration Workflows",
      projectCategory: "Backend Systems",
      projectFilters: ["Web Apps", "Cloud"],
      projectDesc: "Supported API testing, data movement, and system-to-system communication workflows using Postman, cloud tools, and automation-first development.",
      footerLink: [
        {
          name: "View Details",
          url: "#"
        }
      ]
    },
    {
      image: require("./assets/images/msuLogo.png"),
      projectName: "Ethical AI Research Builds",
      projectCategory: "Data Science",
      projectFilters: ["AI", "Data"],
      projectDesc: "Exploring responsible AI, predictive models, and conversational agents designed for practical African business and learning contexts.",
      footerLink: [
        {
          name: "View Details",
          url: "#"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Certifications, Courses, and Continuous Learning in Data Science and AI.",

  achievementsCards: [
    {
      title: "Diploma in Cyber Security",
      subtitle: "Completed comprehensive training in network security, threat mitigation, and cybersecurity best practices. (Alison CPD Certified, Issued: April 2025)",
      image: require("./assets/images/alisonLogo.png"),
      imageAlt: "Alison Certificate Logo",
      footerLink: [
        {
          name: "Verify Certificate",
          url: "#"
        }
      ]
    },
    {
      title: "Artificial Intelligence and Machine Learning in Business",
      subtitle: "Acquired knowledge in AI and ML applications in business, including predictive analytics, natural language processing, and business intelligence. (Alison CPD Certified, Issued: April 2025)",
      image: require("./assets/images/alisonLogo.png"),
      imageAlt: "Alison Certificate Logo",
      footerLink: [
        {
          name: "Verify Certificate",
          url: "#"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Hit me up..."),
  subtitle:
    "Looking for a developer to bring your idea to life? Whether you need a freelance expert or a full agency team through CogniEdge Technologies, my inbox is open.",
  number: "+263-78-663-8282",
  email_address: "mbongeninsingo84@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "",
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  aboutSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
